import React from 'react';

const ErrorBoundaryFallback = () => {
  setTimeout(() => {
    window.location.reload();
    localStorage.setItem('TEST_CRASH', 'false');
  }, 10000);

  return (
    <div
      style={{
        backgroundColor: 'black',
        color: 'white',
        display: 'flex',
        height: '100vh',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1>AIMS Inspection App has encounter an error.</h1>
      <h2>The error has been reported, Inspection App will automatically refresh in 10 seconds.</h2>
    </div>
  );
};

export default ErrorBoundaryFallback;
